export default "__VITE_ASSET__7c913428__"